<template>
  <div :class="`grid gap-${gap} grid-cols-${columns}`">
    <slot></slot>
  </div>
</template>

<script setup>
const props = defineProps({
  gap: { type: Number, default: 2 },
  columns: { type: Number, default: 2 },
});
</script>
